import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { ClientType } from 'src/app/library/enums/client/client.enum';
import { IClientResponse } from 'src/app/library/interfaces/client/client-response';

@Component({
    selector: 'app-new-case-search-clients-card',
    templateUrl: './new-case-search-clients-card.component.html',
    styleUrls: ['./new-case-search-clients-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewCaseSearchClientsCardComponent implements OnInit {
    @Input() client: IClientResponse;

    @Output() clientSelected: EventEmitter<IClientResponse> =
        new EventEmitter<IClientResponse>();

    public readonly clientType = ClientType;

    constructor() {}

    ngOnInit() {
        if (!this.client) throw new Error('Client model is required');
    }

    public selectClient(selectedClient: IClientResponse): void {
        this.clientSelected.emit(selectedClient);
    }
}
